export const getFullName = (customer) => {
    return [customer.name?.given, customer.name?.family].filter(Boolean).join(' ');
};

export const getDisplayName = (customer) => {
    const fullName = getFullName(customer);
    if (!fullName) return 'No Name';
    return fullName;
};

export const getInitials = (name) => {
    var initials = name.match(/\b\w/g) || [];
    return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
};